<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>

    <div class="hp_loginWrap">
      <h2 class="hp_loginTit">
        아이디/비밀번호 찾기
        <p>아래 정보를 정확히 입력해 주세요.</p>
      </h2>

      <div class="hp_loginTabWrap">
        <ul class="hp_loginTab"> <!-- 로그인 탭 -->
          <li :class="{ loginTabOn: statusData.activeTab === '1' }" @click="setActiveTab('1')">아이디 찾기</li>
          <li :class="{ loginTabOn: statusData.activeTab === '2' }" @click="setActiveTab('2')">비밀번호 찾기</li>
        </ul>

        <div v-if="statusData.activeTab === '1'">
          <ul class="hp_loginInput">
            <li class="hp_loginInput_name">
              <input
                type = "text"
                id = 'customer_name'
                v-model="formData.customerName"
                maxlength="20"
                placeholder="이름"
              >
            </li>
            <li class="hp_loginInput_phone">
              <input
                  type = "text"
                  id = 'customer_phone_number'
                  v-model="formData.customerPhoneNumber"
                  maxlength="20"
                  placeholder="핸드폰번호 (- 입력포함)"
                >
            </li>
          </ul>
          <button class="hp_loginBtn" v-on:click="check_form">아이디 찾기</button>
        </div>

        <div v-if="statusData.activeTab === '2'">
          <ul class="hp_loginInput">
            <li>
              <input
                type = "text"
                id = 'customer_login_ID'
                v-model="formData.customerLoginID"
                maxlength="15"
                placeholder="아이디"
              >
            </li>
            <li class="hp_loginInput_search_name">
              <input
                type = "text"
                id = 'customer_name'
                v-model="formData.customerName"
                maxlength="20"
                placeholder="이름"
              >
            </li>
            <li class="hp_loginInput_phone">
              <input
                  type = "text"
                  id = 'customer_phone_number'
                  v-model="formData.customerPhoneNumber"
                  maxlength="20"
                  placeholder="핸드폰번호 (- 입력포함)"
                >
            </li>
          </ul>
          <button class="hp_loginBtn" v-on:click="check_form">비밀번호 찾기</button>
          <div class="hp_loginNoticeRed">
            ※임시 비밀번호를 문자로 발급합니다.
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import { ref } from 'vue'
import {
  search_customer_ID,
  search_customer_password,
  set_temporary_password,
  send_sns
} from '../../ETC/Axios.vue'

export default {
  name: 'Login',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll,
    Spiner
  },
  setup () {
    return {
      formData: ref({
        customerLoginID: '',
        customerName: '',
        customerPhoneNumber: ''
      }),
      statusData: ref({
        activeTab: '1',
        spinnerStatus: false
      })
    }
  },
  watch: {
    'formData.customerPhoneNumber': function (value) {
      let cleanValue = value.replace(/\D/g, '')
      if (cleanValue.length <= 3) {
        this.formData.customerPhoneNumber = cleanValue
      } else if (cleanValue.length <= 7) {
        this.formData.customerPhoneNumber = `${cleanValue.slice(0, 3)}-${cleanValue.slice(3)}`
      } else {
        this.formData.customerPhoneNumber = `${cleanValue.slice(0, 3)}-${cleanValue.slice(3, 7)}-${cleanValue.slice(7, 11)}`
      }
    }
  },
  methods: {
    setActiveTab (tab) {
      this.statusData.activeTab = tab
    },
    generateTemporaryPassword (length = 10) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()'
      let password = ''
      for (let i = 0; i < length; i++) {
        password += characters.charAt(Math.floor(Math.random() * characters.length))
      }
      return password
    },
    check_form: function () {
      if (this.statusData.activeTab === '1') {
        if (
          this.formData.customerName !== '' &&
          this.formData.customerPhoneNumber !== ''
        ) {
          this.statusData.spinnerStatus = true
          search_customer_ID(
            this.formData.customerName,
            this.formData.customerPhoneNumber
          ).then(customers => {
            if (customers.length === 0) {
              this.statusData.spinnerStatus = false
              alert('일치하신 정보가 없습니다.')
            } else {
              const customerIDs = customers.map(customer => customer.customer_login_ID).join(', ')
              send_sns(
                this.formData.customerPhoneNumber,
                `
[(주)행복을주는사람들]
 아이디는 ${customerIDs}입니다.
`
              ).then(result => {
                this.statusData.spinnerStatus = false
                alert('문자로 전송해드렸습니다.')
              })
            }
          })
        } else {
          alert('이름 및 핸드폰번호를 입력해주세요.')
        }
      } else if (this.statusData.activeTab === '2') {
        if (
          this.formData.customerLoginID !== '' &&
          this.formData.customerPhoneNumber !== '' &&
          this.formData.customerPhoneNumber !== ''
        ) {
          this.statusData.spinnerStatus = true
          search_customer_password(
            this.formData.customerLoginID,
            this.formData.customerName,
            this.formData.customerPhoneNumber
          ).then(customers => {
            if (customers.length === 0) {
              this.statusData.spinnerStatus = false
              alert('일치하신 정보가 없습니다.')
            } else {
              const temporaryPassword = this.generateTemporaryPassword()
              set_temporary_password(
                this.formData.customerLoginID,
                temporaryPassword
              ).then(result => {
                send_sns(
                  this.formData.customerPhoneNumber,
                  `
[(주)행복을주는사람들]
임시비밀번호는 ${temporaryPassword}입니다.
`
                ).then(result => {
                  this.statusData.spinnerStatus = false
                  alert('문자로 전송해드렸습니다.')
                })
              })
            }
          })
        } else {
          alert('아이디, 이름, 핸드폰번호를 입력해주세요.')
        }
      }
    }
  },
  mounted () {
    if (this.$route.query.activeTab !== undefined) {
      this.statusData.activeTab = this.$route.query.activeTab
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Login/Search.vue